import { render, staticRenderFns } from "./ShaimOverenoConsent.vue?vue&type=template&id=ee0f6f22&scoped=true&"
import script from "./ShaimOverenoConsent.vue?vue&type=script&lang=js&"
export * from "./ShaimOverenoConsent.vue?vue&type=script&lang=js&"
import style0 from "./ShaimOverenoConsent.vue?vue&type=style&index=0&id=ee0f6f22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0f6f22",
  null
  
)

export default component.exports